import React, { useEffect, useState } from 'react'
import styled from "styled-components"
import Select, { components } from 'react-dropdown-select'
import { withTranslation } from 'react-i18next';

const defaultvalue = ''
const lastdata = []

const DropDown = (props) => {

    const [dropdowndata, setDropdowndata] = useState({
        optionvalue: defaultvalue,
        placeholder: defaultvalue
    })

    const [clearID, setClearID] = useState()
    const [clearallitems, setClearallitems] = useState()

    useEffect(() => {
        let dlabel = props.dlabel !== undefined && props.dlabel !== null && props.dlabel
        let ddata = props.ddata !== undefined && props.ddata !== null && props.ddata
        let placeholder = []
        let optionvalue = []
        dlabel && dlabel.map(data =>
            ddata && ddata.map((lres, index) => {
                if (lres.filterGroupID === data.id) {
                    placeholder.push(data.fields.labelName.value)
                    let res = lres.filterItems.map(item => ({
                        value: item.filterItemID,
                        itemname: item.filterItemName,
                        label: `${item.filterItemName} (${item.filterItemCount})`,
                        count: item.filterItemCount,
                        groupid: lres.filterGroupID,
                        itemselection: item.filterItemIsSelected
                        //itemselection: false
                    }))
                    optionvalue.push(res)
                }
            }
            )
        )
        setDropdowndata({
            placeholder: placeholder,
            optionvalue: optionvalue
        })
    }, [props.dlabel, props.ddata])

    useEffect(() => {
        //console.log(props.clearallitems)
        setClearallitems(props.clearallitems)
    }, [props.clearallitems])

    const { t } = props

    const customContentRenderer = ({ props, state, methods }) => {
        return <div className="dd-labelname" style={{ cursor: "pointer" }}
            onClick={!state.dropdown ? () => methods.dropDown("open") : () => methods.dropDown("close")}>
            {props.placeholder}
        </div>
    };

    // Inside filters - checkbox part 

    const customDropdownRenderer = ({ props, state, methods }) => {
        //console.log(state)
        //console.log(state.values)
        const regexp = new RegExp(state.search, "i")
        const checkBoxStatus = (state, option) => {
            // state.values.filter(data => data.value === option.value).length > 0
            return (state.values.filter(data => data.value === option.value).length > 0)
        }

        const clearedFilter = localStorage.getItem("clearedFilterValue")
        if (clearedFilter) {
            const stateValues = []
            let i = 0
            let stateChange = false
            state.values.forEach(element => {
                let flag = true
                clearedFilter.split('|').forEach(filterValue => {
                    if (element.value === filterValue) {
                        flag = false
                        stateChange = true
                    }
                })
                if (flag) {
                    stateValues[i++] = element
                    stateChange = true
                }
            });

            if (stateChange && stateValues && stateValues.length >= 0)
                state.values = stateValues

            localStorage.removeItem("clearedFilterValue")
        }

        // if(state.values.length === 0){
        //     let stateValuesArray = []
        //     let i = 0
        //     props.options.map(item => {
        //         if(item.itemselection){
        //             stateValuesArray[i++] = item
        //         }
        //     })
        //     if(stateValuesArray && stateValuesArray.length > 0) {
        //         state.values = stateValuesArray
        //     }
        // }

        return (
            <div className="dropdown-container">
                <div className="labelname">
                    {
                        props.options
                            .filter(item => regexp.test(item[props.searchBy] || item.label))
                            .map(option => {
                                //let optselection = option.itemselection ? option : null
                                //state.values(optselection)
                                //console.log(state.values)
                                //console.log(option)
                                return <Item
                                    key={option.value}
                                    className={option.count !== 0 ? state.values.filter(data => data.value === option.value).length > 0 ? 'labellist labellist-active' : 'labellist' : "labellist labellist-disable"}
                                    onClick={
                                        option.count !== 0 ?
                                            () => methods.addItem(option) :
                                            (event) => event.preventDefault()
                                    }
                                >
                                    <input
                                        type="checkbox"
                                        onChange={
                                            option.count !== 0 ?
                                                state.values.filter(data => data.value === option.value).length > 0 ? () => methods.removeItem(option) : () => methods.addItem(option) :
                                                //option.itemselection ? methods.removeItem(option) : () => methods.addItem(option) :
                                                (event) => event.preventDefault()
                                        }
                                        //onClick={state.values.indexOf(option) !== -1}
                                        checked={
                                            //state.values.indexOf(option) !== -1
                                            //state.values.indexOf(option) !== -1
                                            //console.log('props.values: '+JSON.stringify(option))
                                            //state.values.filter(data => data.value === option.value).length > 0
                                            // state.values.count > 0 ? 
                                            state.values.filter(data => data.value === option.value).length > 0 ? true : false
                                            //  : option.filterItemIsSelected
                                            //optselection !== null ? true : false
                                        }
                                        disabled={option.count === 0}
                                    />
                                    <ItemLabel
                                        onClick={
                                            option.count !== 0 ?
                                                () => { methods.addItem(option) }
                                                :
                                                (event) => event.preventDefault()
                                        }
                                        disabled={option.count === 0}
                                        className={state.values.filter(data => data.value === option.value).length > 0 ? 'active' : ''}
                                    >
                                        {option.label}
                                    </ItemLabel>
                                </Item>
                            })
                    }
                </div>
                <div className="button-container">
                    {/* <input
                        type="text"
                        value={state.search}
                        onChange={methods.setSearch}
                        placeholder="Type anything"
                    /> */}
                    {

                        <Button className="btn btn-clear" onClick={state.values.length > 0 ? methods.clearAll : null}>
                            {t('RecipeFinder_ClearAll')}
                        </Button>
                    }
                    {
                        <Button
                            className="btn btn-primary"
                            onClick={state.values.length !== 0 ? () => { methods.dropDown("close"); submitData(methods) } : () => { methods.dropDown("close"); clearids(props.options) }}
                        //disabled = { state.values.length === 0 ? true : false  }                            
                        >
                            {t('RecipeFinder_Done')}
                        </Button>
                    }
                    {/* {state.values.length === props.options.length ? (
                        <Button className="clear" onClick={methods.clearAll}>
                            Clear all
                        </Button>
                    ) : (
                            <Button onClick={methods.selectAll}>Select all</Button>
                        )} */}
                </div>
            </div>
        );
    };

    /* const customItemRenderer = ({ item, itemIndex, props, state, methods }) => (
        <div onClick={() => methods.addItem(item)}>
            <input type="checkbox" checked={methods.isSelected(item)} />{" "}
            {item.label}
        </div>
    ); */

    /* const StyledSelect = styled(Select)`
    .react-dropdown-select-dropdown {
        overflow: initial;
        color:red;
    }
    `; */

    const Item = styled.div`
        display: flex;
        margin: 10px;
        align-items: baseline;
    `;

    const ItemLabel = styled.div`
        margin: 5px 10px;
    `;

    const Button = styled.button`
        background: none;
        border: 1px solid #555;
        color: #555;
        border-radius: 3px;
        margin: 10px 10px 0;
        padding: 3px 5px;
        font-size: 10px;
        text-transform: uppercase;
        cursor: pointer;
        outline: none;

        &.clear {
        }

        :hover {
        }
    `;

    const [resdata, setResdata] = useState({
        data: '',
        gid: ''
    })

    const onChange = (data, res) => {
        console.log(data)
        //props.filterlist(data)
        let gid = res.map(items => items.map(item => item.groupid))
        data && data.length === 0 ? setResdata({ data: lastdata[0], gid: gid }) : setResdata({ data: data, gid: gid })
    }

    useEffect(() => {
        //console.log(props.clearfilteritem)
    }, [props.clearfilteritem])

    const clearids = (propsdata) => {
        let gid = propsdata.map(pdata => pdata.groupid)
        setClearID(propsdata)
        props.clearids(gid[0])
    }

    const submitData = () => {
        return resdata !== undefined && resdata.length !== 0 && props.result(resdata)
    }

    return (
        dropdowndata.placeholder.length > 0 && dropdowndata.placeholder.map((d, i) => {
            let optvalue = dropdowndata.optionvalue.filter((data, index) => (i === index))
            let filterdata = props.apidata.data.filters && props.apidata.data.filters.filter(items => d === items.filterGroupName)
            let enableitems = filterdata && filterdata.map(items => items.filterItems.filter(item => item.filterItemIsSelected))
            //console.log('enableitems: '+JSON.stringify(optvalue[0]))

            return (

                <div className="fields fields-filterblock" key={`${d}${i}`} >
                    <Select
                        //styles={colourStyles}
                        className={(enableitems && enableitems[0].length > 0) ? 'active' : ''}
                        key={`${d}${i}`}
                        separator={false}
                        dropdownHandleRenderer={({ state }) => (
                            // if dropdown is open show "–" else show "+"
                            <span> {state.dropdown ? <i className='fa fa-angle-up' /> : <i className='fa fa-angle-down' />} </span>
                        )}
                        // dropdownPosition="auto"
                        placeholder={d}
                        options={optvalue[0]}
                        color=""
                        multi
                        contentRenderer={customContentRenderer}
                        dropdownRenderer={customDropdownRenderer}
                        //itemRenderer = {customItemRenderer}
                        //optionRenderer={optionRenderer}
                        separator={false}
                        dropdownPosition="bottom"
                        onChange={(values) => onChange(values, optvalue)}
                    //values={optvalue.filter(option => option.itemselection === true)}
                    />
                </div>
                // </div>

            )
        })
    )
};

export default withTranslation()(DropDown);
